module.exports = __webpack_public_path__ + "static/media/breadcrumb-tail-selected.51ba8373.svg";